import { OrganizationKeyName } from "../../../model/Organization";

export const UPSERT_USER_TERM_VERSION = "UPSERT_USER_TERM_VERSION";
export type UpsertUserTermVersionAction = {
  type: typeof UPSERT_USER_TERM_VERSION;
  organization: OrganizationKeyName;
  data: any;
};
export const upsertUserTermVersionAction = (
  organization: OrganizationKeyName,
  data: any
): UpsertUserTermVersionAction => ({
  type: UPSERT_USER_TERM_VERSION,
  organization,
  data,
});

export const UPSERT_USER_TERM_VERSION_FAIL = "UPSERT_USER_TERM_VERSION_FAIL";
export type UpsertUserTermVersionFailAction = {
  type: typeof UPSERT_USER_TERM_VERSION_FAIL;
  organization: OrganizationKeyName;
};
export const upsertUserTermVersionFailAction = (
  organization: OrganizationKeyName
): UpsertUserTermVersionFailAction => ({
  type: UPSERT_USER_TERM_VERSION_FAIL,
  organization,
});

export const UPSERT_USER_TERM_VERSION_SUCCESS =
  "UPSERT_USER_TERM_VERSION_SUCESS";
export type UpsertUserTermVersionSuccessAction = {
  type: typeof UPSERT_USER_TERM_VERSION_SUCCESS;
  organization: OrganizationKeyName;
};
export const upsertUserTermVersionSuccessAction = (
  organization: OrganizationKeyName
): UpsertUserTermVersionSuccessAction => ({
  type: UPSERT_USER_TERM_VERSION_SUCCESS,
  organization,
});
